import { createContext } from 'react';
import { RelatedEntityPath } from '../../Path/@Model/RelatedEntityPath';

export default createContext<RelatedEntityPath>(undefined);